/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFacilityUserAccountQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetFacilityUserAccountQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, contact: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } } | null };

export type UpdateFacilityUserAccountMutationVariables = Types.Exact<{
  input: Types.UserInput;
}>;


export type UpdateFacilityUserAccountMutation = { __typename?: 'Mutation', updateCurrentUser?: { __typename?: 'User', id: string } | null };


export const GetFacilityUserAccountDocument = gql`
    query GetFacilityUserAccount($id: ID!) {
  user(id: $id) {
    id
    contact {
      id
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetFacilityUserAccountQuery__
 *
 * To run a query within a React component, call `useGetFacilityUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityUserAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFacilityUserAccountQuery(baseOptions: Apollo.QueryHookOptions<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables> & ({ variables: GetFacilityUserAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>(GetFacilityUserAccountDocument, options);
      }
export function useGetFacilityUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>(GetFacilityUserAccountDocument, options);
        }
export function useGetFacilityUserAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>(GetFacilityUserAccountDocument, options);
        }
export type GetFacilityUserAccountQueryHookResult = ReturnType<typeof useGetFacilityUserAccountQuery>;
export type GetFacilityUserAccountLazyQueryHookResult = ReturnType<typeof useGetFacilityUserAccountLazyQuery>;
export type GetFacilityUserAccountSuspenseQueryHookResult = ReturnType<typeof useGetFacilityUserAccountSuspenseQuery>;
export type GetFacilityUserAccountQueryResult = Apollo.QueryResult<GetFacilityUserAccountQuery, GetFacilityUserAccountQueryVariables>;
export const UpdateFacilityUserAccountDocument = gql`
    mutation UpdateFacilityUserAccount($input: UserInput!) {
  updateCurrentUser(input: $input) {
    id
  }
}
    `;
export type UpdateFacilityUserAccountMutationFn = Apollo.MutationFunction<UpdateFacilityUserAccountMutation, UpdateFacilityUserAccountMutationVariables>;

/**
 * __useUpdateFacilityUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateFacilityUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilityUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilityUserAccountMutation, { data, loading, error }] = useUpdateFacilityUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilityUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFacilityUserAccountMutation, UpdateFacilityUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFacilityUserAccountMutation, UpdateFacilityUserAccountMutationVariables>(UpdateFacilityUserAccountDocument, options);
      }
export type UpdateFacilityUserAccountMutationHookResult = ReturnType<typeof useUpdateFacilityUserAccountMutation>;
export type UpdateFacilityUserAccountMutationResult = Apollo.MutationResult<UpdateFacilityUserAccountMutation>;
export type UpdateFacilityUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateFacilityUserAccountMutation, UpdateFacilityUserAccountMutationVariables>;